import React from "react";
import JwtClient from "./JwtClient";
import {Alert} from "react-bootstrap";

export default class StaffAddClient extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alert: '',
            clients: [],

            userPassword: '',
            userEmail: '',
            name: '',
            code: '',
            shipOnCredit: false,
            npi: false,
            bxb: false,
            npg: false,
            contactName: '',
        }
    }


    render() {
        if (!!this.state.alert) {
            return <Alert>{this.state.alert}</Alert>
        }

        return (
            <div className="container mt-5">
                <form onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col">
                            <label>Password</label>
                            <input
                                className="form-control"
                                value={this.state.userPassword}
                                onChange={e => {
                                    this.setState({userPassword: e.target.value})
                                }}
                            />
                        </div>
                        <div className="col">
                            <label>Email</label>
                            <input
                                className="form-control"
                                value={this.state.userEmail}
                                onChange={e => {
                                    this.setState({userEmail: e.target.value})
                                }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>Name</label>
                            <input
                                className="form-control"
                                value={this.state.name}
                                onChange={e => {
                                    this.setState({name: e.target.value})
                                }}
                            />
                        </div>
                        <div className="col">
                            <label>Code</label>
                            <input
                                className="form-control"
                                value={this.state.code}
                                onChange={e => {
                                    this.setState({code: e.target.value})
                                }}
                            />
                        </div>
                        <div className="col">
                            <label>Contact name</label>
                            <input
                                className="form-control"
                                value={this.state.contactName}
                                onChange={e => {
                                    this.setState({contactName: e.target.value})
                                }}
                            />
                        </div>
                    </div>

                        <div className="form-check">
                            <input
                                id="ship-on-credit-checkbox"
                                className="form-check-input"
                                type='checkbox'
                                value={this.state.shipOnCredit}
                                onChange={e => {
                                    this.setState((prevState) => {
                                        return {shipOnCredit: !prevState.shipOnCredit}
                                    })
                                }}
                            />
                            <label htmlFor="ship-on-credit-checkbox">Ship on credit</label>
                        </div>
                        <div className="form-check">
                            <input
                                id="npi-checkbox"
                                className="form-check-input"
                                type='checkbox'
                                value={this.state.npi}
                                onChange={e => {
                                    this.setState((prevState) => {
                                        return {npi: !prevState.npi}
                                    })
                                }}
                            />
                            <label htmlFor="npi-checkbox">NPI</label>
                        </div>
                        <div className="form-check">
                            <input
                                id="bxb-checkbox"
                                className="form-check-input"
                                type='checkbox'
                                value={this.state.bxb}
                                onChange={e => {
                                    this.setState((prevState) => {
                                        return {bxb: !prevState.bxb}
                                    })
                                }}
                            />
                            <label htmlFor="bxb-checkbox">BXB</label>
                        </div>
                    <div className="form-check">
                        <input
                            id="npg-checkbox"
                            className="form-check-input"
                            type='checkbox'
                            value={this.state.npg}
                            onChange={e => {
                                this.setState((prevState) => {
                                    return {npg: !prevState.npg}
                                })
                            }}
                        />
                        <label htmlFor="npg-checkbox">NPG</label>
                    </div>

                    <button className="btn btn-primary" type='submit'>Sumbit</button>
                </form>

                <table className="table mt-3">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Code</th>
                        <th>User email</th>
                        <th>Ship on credit</th>
                        <th>Contact name</th>
                        <th>LMS</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.clients.map((v, i) => {
                        return (
                            <tr key={i}>
                                <td>{v.name}</td>
                                <td>{v.code}</td>
                                <td>{v.user_email}</td>
                                <td>{v.ship_on_credit? 'yes': 'no'}</td>
                                <td>{v.contact_name}</td>
                                <td>{v.last_mile_services.join(', ')}</td>
                            </tr>
                        )
                    })}
                    </tbody>

                </table>
            </div>
        )
    }

    handleSubmit = (e) => {
        e.preventDefault()
        let lms = []
        if (this.state.npi) {
            lms.push('NPI')
        }
        if (this.state.bxb) {
            lms.push('BXB')
        }
        if (this.state.npg) {
            lms.push('NPG')
        }

        JwtClient.post('/api/v1/admin/clients', {
            user_password: this.state.userPassword,
            client: {
                user_email: this.state.userEmail,
                name: this.state.name,
                code: this.state.code,
                ship_on_credit: this.state.shipOnCredit,
                last_mile_services: lms,
                contact_name: this.state.contactName,
            }
        })
            .then(response => {
                if (response.status === 201) {
                    this.setState({alert: 'successfully created'})
                }
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        this.setState({alert: 'Unauthorized'})
                    }
                    this.setState({alert: 'failed, status: ' + error.response.status + ' Data: ' + JSON.stringify(error.response.data)});
                } else {
                    this.setState({alert: JSON.stringify(error)});
                }
            })
    }

    componentDidMount() {
        JwtClient.get('/api/v1/admin/clients')
            .then(response => {
                this.setState({clients: response.data.clients})
            })
    }
}